/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum FSFBInputType {
  NONE = 0,
  TEXT = 1,
  EMAIL = 2,
  URL = 3,
  PASSWORD = 4,
  DATETIME = 5,
  NUMBER = 6,
  TEL = 7,
}
